
import angular from 'angular';
import uirouter from 'angular-ui-router';

import brand from '../../service/brand';
import user from '../../service/user';
import summaryRanking from '../../service/summaryRanking';

import menuLayout from '../../directive/menu-layout';
import dateFormat from '../../directive/date-format';
import storeDateSelector from '../../directive/store-date-selector';

import routing from './summaryRanking.routes';
import SummaryRankingController from './summaryRanking.controller';

export default angular.module('page.summaryRanking', [
		uirouter,

		brand,
		user,
		summaryRanking,

		menuLayout,
		dateFormat,
		storeDateSelector,
		'ui.bootstrap.datetimepicker',
	])
	.config(routing)
	.controller('SummaryRankingController', SummaryRankingController)
	.name;



// WEBPACK FOOTER //
// ./src/page/summaryRanking/index.js